const ActionTypes = {
  ENTRY: 10,
  WAIT: 0,
  CONDITION: 1,
  EMAIL: 2,
  INTEGRATION: 4,
  NOTIFICATION: 5,
  WEBHOOK: 6,
  END_AUTOMATION: 7,
  GOTO: 8
}

export default ActionTypes



// WEBPACK FOOTER //
// ./src/utils/dictionaries/actionTypes.js